// import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

// let nijiSliders = document.querySelectorAll('.niji-swiper');

// if(nijiSliders.length > 0){

//   nijiSliders.forEach(function(nijiSlider){

//     let nijiSliderId = nijiSlider.dataset.swiperId;

//     let paginationAttrs = false,
//         navAttrs = false,
//         autoplay = false;

//     if(nijiSlider.dataset.autoplay) {
//       autoplay = {
//         delay: 3000
//       }
//     }

//     if(nijiSlider.dataset.pagination) {
//       paginationAttrs = {
//         el: '.' + nijiSliderId + ' .niji-swiper__pagination',
//         type: nijiSlider.dataset.paginationType,
//         clickable: true
//       }
//     }

//     if(nijiSlider.dataset.nav) {
//       navAttrs = {
//         nextEl: '.' + nijiSliderId + ' .niji-swiper__button--next',
//         prevEl: '.' + nijiSliderId + ' .niji-swiper__button--prev',
//       }
//     }

//     const swiper = new Swiper('.' + nijiSliderId, {
//       slidesPerView: nijiSlider.dataset.perView,
//       direction: nijiSlider.dataset.dir,
//       autoHeight: nijiSlider.dataset.dir === 'vertical' ? true : false,
//       centeredSlides: nijiSlider.dataset.centeredSlide,
//       spaceBetween: nijiSlider.dataset.spaceBetween,
//       autoplay: autoplay,
//       loop: nijiSlider.dataset.loop,
//       pagination: paginationAttrs,
//       navigation: navAttrs,
//       modules: [Navigation, Pagination, Autoplay],
//     });
//   });
// }
